import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import awlLogo from "./awl-logo.png";
import { db } from "./firebase";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";

const HomePage = () => {
  const navigate = useNavigate();

  const userName = "Sagar L";
  const points = 120;
  const rank = 5;

  const [recentInsights, setRecentInsights] = useState([]);
  const [loadingInsights, setLoadingInsights] = useState(true);

  useEffect(() => {
    const fetchInsights = async () => {
      setLoadingInsights(true);
      try {
        const q = query(
          collection(db, "insights_test"),
          orderBy("date", "desc"),
          limit(10)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => {
          const d = doc.data();
          const dateStr = d.date?.seconds
            ? new Date(d.date.seconds * 1000).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })
            : "No date";
          return {
            id: doc.id,
            title: d.title,
            date: dateStr,
            status: d.status,
          };
        });
        setRecentInsights(data);
      } catch (err) {
        console.error("Error fetching insights:", err);
      } finally {
        setLoadingInsights(false);
      }
    };
    fetchInsights();
  }, []);

  const handleAddInsightClick = () => {
    navigate("/insight");
  };

  return (
    <div>
      <div className="app-header">
        <h1 className="app-name-header">
          insight<span className="app-name-highlight">360</span>
        </h1>
        <img src={awlLogo} alt="AWL Logo" className="company-logo-header" />
      </div>

      <div className="main-content">
        <div className="welcome-card">
          <div className="welcome-text">
            <h2>Welcome back, <span className="user-name">{userName.split(" ")[0]}</span>!</h2>
            <p>Ready to make an impact?</p>
          </div>
          <div className="welcome-rank">
            <p className="points">{points} pts</p>
            <p className="rank">Rank #{rank}</p>
            <button className="leaderboard-link" onClick={() => navigate("/leaderboard")}>
              Leaderboard &gt;
            </button>
          </div>
        </div>

        <div className="card insight-card" onClick={handleAddInsightClick}>
          <div className="insight-card-content">
            <div className="insight-icon pulse">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </div>
            <div className="insight-text">
              <p className="title">Add a New Insight</p>
              <p className="subtitle">Help your organization grow.</p>
            </div>
          </div>
          <div className="chevron-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <p className="title">My Recent Insights</p>
            <div className="status-legend">
              <span className="legend-item"><span className="legend-color-dot pending"></span>Pending</span>
              <span className="legend-item"><span className="legend-color-dot reviewed"></span>Reviewed</span>
            </div>
          </div>

          <div className="insights-list">
            {loadingInsights ? (
              <div className="loading-text">Loading...</div>
            ) : (
              recentInsights.map((insight) => (
                <div
                  className={`insight-item status-${insight.status?.toLowerCase()}`}
                  key={insight.id}
                >
                  <div className="insight-item-details">
                    <p className="item-title">{insight.title}</p>
                    <p className="item-meta">Submitted on: {insight.date}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;